// extracted by mini-css-extract-plugin
export default {"transactionCard":"TransactionInfo_transactionCard__RPmSx","transactionCardInfo":"TransactionInfo_transactionCardInfo__rb+lw","paymentHolder":"TransactionInfo_paymentHolder__9B9op"};